import * as React from 'react';

import * as styles from '../../../Styles/svgShadow.css';

const IconCaptionsActive = () => (
    <svg viewBox="0 0 100 100" className={styles.svgShadow}>
        <path d="M26.675,87.745v-12.56h-6.28l-9.42-9.42V31.675l9.42-9.42h59.21l9.42,9.42v34.091
        l-9.42,9.42H48.654L26.675,87.745z M29.366,50.514v4.037h18.84v-4.037H29.366z
        M29.366,41.095v4.037h40.371v-4.037H29.366z"/>
    </svg>
);

export default IconCaptionsActive;